import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';
import { Call } from '../types';

import axios from './axios';

export interface UseMakeCallVariables {
  caleeId: String;
}

export interface UseMakeCallData extends Call {}

export function useMakeCall() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseMakeCallData,
    AxiosError<UseMakeCallData>,
    UseMakeCallVariables
  >(
    (variables) => {
      const data = variables;

      return axios
        .post<UseMakeCallData>(`/posht/yashar/calls/${data.caleeId}/`, {
          title: 'tof',
        })
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSettled: () => {
        queryClient.invalidateQueries('places');
      },
    },
  );
}
